module.exports = __webpack_public_path__ + "static/WebSiteSmallLogo-ClerkieColor-fb1fb26f67ebf92665d3642524b1fd57.png";